import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "./../imgs/logo@2x.png";
import ReactGA from "react-ga";
import "./blog.css";

class Blog extends Component {
  constructor(props) {
    super(props);
    ReactGA.ga("send", "pageview", window.location.hash);
  }

  render() {
    return (
      <div className="blog">
        <div className="blog-bar">
          <div className="blog-bar-logo">
            <img src={logo} />
          </div>
          <div className="blog-bar-options">
            <div className="blog-bar-option1 montserrat fw-bold">
              <Link to="/">WEB</Link>
            </div>
          </div>
        </div>
        <iframe
          src="https://adivorpuebla.blogspot.com/"
          width="100%"
          height="100%"
        />
      </div>
    );
  }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/sections/Blog.js